import { dictToURI, genericService } from '../_utilities/generic';

import api from '../_api';

const extendedCollateralService = (pathname) => ({
  getImagesFromFolder(kwargs = null) {
    let str;
    if (kwargs) {
      str = kwargs.search;
    }
    return api.get(`/collateral/folder/${kwargs.id}/?search=${str}`);
  },
  downloadImage(pk) {
    return api.get(`/image-download/${pk}/`);
  },
  getCollateralLink(folderId, customerId) {
    return api.post('/collateral_link', { folder_id: folderId, customer_id: customerId });
  },
  getSharedItems(kwargs = {}) {
    return api.get(`/collateral/shared_images/${dictToURI(kwargs)}/`);
  },
  ...genericService(pathname),
});

export default extendedCollateralService;
